var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.585 16.093L17.0724 13.5603C17.0724 13.5603 16.4012 12.9405 15.7662 13.3267L14.3693 14.8087L13.9702 15.2847C13.2717 16.066 11.3396 14.3955 11.3396 14.3955C9.89736 13.6591 6.66813 9.92283 6.66813 9.92283C5.08073 8.1086 5.96968 7.31825 5.96968 7.31825L6.41415 6.87816L7.95619 5.40523C7.95619 5.40523 8.79978 4.91126 6.51393 2.99824L3.93781 0.375692C3.93781 0.375692 3.23935 -0.261982 2.59532 0.124215L1.15305 1.65104L0.708582 2.09112C-0.379921 3.71674 0.109906 6.474 0.109906 6.474C1.99664 13.5064 10.1423 18.8233 10.1423 18.8233C16.9998 22.9547 19.0317 20.2513 19.0317 20.2513L19.4762 19.8741L20.9729 18.4461C20.9729 18.4461 21.7892 17.9611 19.576 16.102L19.585 16.093Z",
    fill: "#F9FBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.69bfdc94b4776cb99f330f401bd8cb9a.svg";
export { ForwardRef as ReactComponent };